import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Grid } from "@mui/material";
import isEqual from "react-fast-compare";
import Table from "../common/tableWithBackEndPagination";
import ConfirmDialoag from "../common/ConfirmDialoag";
import Loader from "../../Layout/Loader";
import Button from "../common/Button";
import TextField from "../common/TextField";
import MenuItem from "@mui/material/MenuItem";
import AddPmsIntervalModal from "./addPmsInterval";
import { PaginationConfig } from "../../Helpers";

let source;

const formDefaultState = {
  category: "",
  fleetTypes: [],
  baselineInterval: "",
  baselineIntervalDays: "",
};

const mapPmsItem = (item) => ({
  ...item,
  active: item.active !== undefined ? item.active : item.archive === false,
});

const pmsDataFormat = (data, id) => {
  const active =
    data?.active !== undefined ? data.active : !(data?.archive ?? false);

  return {
    id: id || 0,
    category: data?.category ? data.category.trim() : "",
    fleetType: data?.fleetType || "",
    baselineInterval: data?.baselineInterval
      ? parseInt(data.baselineInterval, 10)
      : 0,
    baselineIntervalDays: data?.baselineIntervalDays
      ? parseInt(data.baselineIntervalDays, 10)
      : 0,
    attributes: {},
    active,
    archive: data?.archive !== undefined ? data.archive : !active,
    archiveTime: data?.archiveTime ?? null,
  };
};

const formFromItem = (item) => ({
  category: item?.category || "",
  fleetTypes: item?.fleetType ? [item.fleetType] : [],
  baselineInterval: item?.baselineInterval ?? "",
  baselineIntervalDays: item?.baselineIntervalDays ?? "",
});

class PmsIntervalsList extends Component {
  constructor() {
    super();
    this.state = {
      ...PaginationConfig,
      selectedItem: "",
      addOption: false,
      editOption: false,
      defaultList: false,
      onDeleteConfirmation: false,
      statusConfirmOpen: false,
      statusItem: null,
      statusConfirmLabel: "",
      tableData: [],
      pagData: "",
      form: { ...formDefaultState },
      isVisableBtn: false,
      isVisableBtnforEdit: false,
      loading: false,
      editLoading: false,
      categories: [],
      categoriesLoading: false,
      submitting: false,
      activeFilter: 2,
      plateNo: "",
      categoryFilter: "",
      itemCode: "",
      completed: 2,
      wanted: 2,
    };
  }

  componentDidMount() {
    this.fetchCategories();
    this.getPmsIntervals();
  }

  componentWillUnmount() {
    if (source) {
      source.cancel();
    }
  }

  ensureFleetTypeInCategories = (fleetType, categories = []) => {
    if (!fleetType) return categories;
    return categories.includes(fleetType)
      ? categories
      : [...categories, fleetType];
  };

  fetchCategories = () => {
    this.setState({ categoriesLoading: true });
    fetch(`/api/vehiclecategorys/get?page=1&limit=500&category=`)
      .then((response) => {
        if (response.ok) {
          response.json().then((res) => {
            if (res.status === "success") {
              const raw = res.data?.data ?? res.data ?? [];
              const list = Array.isArray(raw) ? raw : [];
              const categories = list
                .map((item) =>
                  typeof item === "string" ? item : item?.categoryName,
                )
                .filter(Boolean);
              this.setState({ categories, categoriesLoading: false });
            } else {
              this.setState({ categoriesLoading: false });
            }
          });
        } else {
          this.setState({ categoriesLoading: false });
        }
      })
      .catch(() => {
        this.setState({ categoriesLoading: false });
      });
  };

  getPmsIntervals = () => {
    const {
      page,
      pageSize,
      itemSearch,
      activeFilter,
      plateNo,
      categoryFilter,
      itemCode,
      completed,
      wanted,
    } = this.state;
    if (!this.props.logInUser?.id) return;

    this.setState({ loading: true });
    const params = new URLSearchParams({
      page,
      limit: pageSize,
      search: itemSearch || "",
      active: activeFilter,
    });
    if (plateNo) params.append("plateNo", plateNo);
    if (categoryFilter) params.append("category", categoryFilter);
    if (itemCode) params.append("itemCode", itemCode);
    if (completed !== "" && completed !== null && completed !== undefined) {
      params.append("completed", completed);
    }
    if (wanted !== "" && wanted !== null && wanted !== undefined) {
      params.append("wanted", wanted);
    }
    const apiCall = `/api/pmsintervals/get?${params.toString()}`;
    source = axios.CancelToken.source();

    axios
      .get(apiCall, { cancelToken: source.token })
      .then((response) => {
        const res = response.data;
        if (res.status === "success") {
          const udata = (res.data?.data || []).map(mapPmsItem);
          this.setState({
            tableData: udata,
            defaultList: true,
            pagData: res.data,
            loading: false,
          });
        } else if (res?.statusCode === "440") {
          window.location.replace("/login");
        } else if (res.statusCode) {
          const err = res?.message?.split(":");
          if (err?.[1]) {
            toast.error(this.props.translate(err[1].replace(")", "")));
          }
          this.setState({ loading: false, defaultList: true });
        }
      })
      .catch(() => {
        this.setState({ loading: false, defaultList: true });
      });
  };

  fetchPmsIntervalById = (id) => {
    this.setState({ editLoading: true, defaultList: false });

    return fetch(`/api/pmsintervals/${id}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((res) => {
        if (res.status === "success") {
          const item = mapPmsItem(res.data || {});
          this.setState((prevState) => ({
            editOption: true,
            selectedItem: item,
            editLoading: false,
            categories: this.ensureFleetTypeInCategories(
              item.fleetType,
              prevState.categories,
            ),
            form: formFromItem(item),
          }));
          return item;
        }
        if (res?.statusCode === "440") {
          window.location.replace("/login");
        } else if (res.statusCode) {
          const err = res?.message?.split(":");
          if (err?.[1]) {
            toast.error(this.props.translate(err[1].replace(")", "")));
          }
        }
        this.setState({ editLoading: false, defaultList: true });
        return null;
      })
      .catch(() => {
        toast.error(this.props.translate("somethingwentWrong"));
        this.setState({ editLoading: false, defaultList: true });
        return null;
      });
  };

  removeItem = (selected) => {
    this.setState({
      onDeleteConfirmation: true,
      selectedItem: selected?.[0] || selected,
    });
  };

  deleteItem = () => {
    const { selectedItem } = this.state;
    if (!selectedItem?.id) return;

    this.setState({ submitting: true });
    fetch(`/api/pmsintervals/${selectedItem.id}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((res) => {
        if (res.status === "success") {
          toast.success(this.props.translate("deletedSuccessfully"));
          this.getPmsIntervals();
        } else if (res?.statusCode === "440") {
          window.location.replace("/login");
        } else if (res.statusCode) {
          const err = res?.message?.split(":");
          if (err?.[1]) {
            toast.error(this.props.translate(err[1].replace(")", "")));
          }
        }
      })
      .catch(() => {
        toast.error(this.props.translate("somethingwentWrong"));
      })
      .finally(() => {
        this.setState({
          form: { ...formDefaultState },
          onDeleteConfirmation: false,
          addOption: false,
          defaultList: true,
          submitting: false,
        });
      });
  };

  onCancel = () => {
    this.setState({ onDeleteConfirmation: false });
  };

  handleChangeRowsPerPage = (value) => {
    this.setState({ pageSize: value }, () => this.getPmsIntervals());
  };

  handleChangePage = (value) => {
    this.setState({ page: value }, () => this.getPmsIntervals());
  };

  SearchItem = (searchValue) => {
    if (source) {
      source.cancel();
    }
    this.setState({ page: 1, itemSearch: searchValue }, () =>
      this.getPmsIntervals(),
    );
  };

  handleActiveFilterChange = (event) => {
    const activeFilter = parseInt(event.target.value, 10);
    if (source) {
      source.cancel();
    }
    this.setState({ page: 1, activeFilter }, () => this.getPmsIntervals());
  };

  handleFilterChange = (name) => (event) => {
    let value = event.target.value;
    if (name === "completed" || name === "wanted") {
      value = parseInt(value, 10);
    }
    this.setState({ [name]: value });
  };

  applyFilters = () => {
    if (source) {
      source.cancel();
    }
    this.setState({ page: 1 }, () => this.getPmsIntervals());
  };

  clearFilters = () => {
    if (source) {
      source.cancel();
    }
    this.setState(
      {
        page: 1,
        plateNo: "",
        categoryFilter: "",
        itemCode: "",
        completed: 2,
        wanted: 2,
      },
      () => this.getPmsIntervals(),
    );
  };

  renderFilterFields = () => (
    <Grid container spacing={2} style={{ marginBottom: 12, width: "100%" }}>
      <Grid item xs={12} sm={6} md={2}>
        <TextField
          fullWidth
          label={this.props.translate("plateNo")}
          value={this.state.plateNo}
          onChange={this.handleFilterChange("plateNo")}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={2}>
        <TextField
          fullWidth
          label={this.props.translate("category")}
          value={this.state.categoryFilter}
          onChange={this.handleFilterChange("categoryFilter")}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={2}>
        <TextField
          fullWidth
          label={this.props.translate("itemCode")}
          value={this.state.itemCode}
          onChange={this.handleFilterChange("itemCode")}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={2}>
        <TextField
          select
          fullWidth
          label={this.props.translate("completed")}
          value={this.state.completed}
          onChange={this.handleFilterChange("completed")}
        >
          <MenuItem value={2}>{this.props.translate("all")}</MenuItem>
          <MenuItem value={1}>{this.props.translate("true")}</MenuItem>
          <MenuItem value={0}>{this.props.translate("false")}</MenuItem>
        </TextField>
      </Grid>
      <Grid item xs={12} sm={6} md={2}>
        <TextField
          select
          fullWidth
          label={this.props.translate("wanted")}
          value={this.state.wanted}
          onChange={this.handleFilterChange("wanted")}
        >
          <MenuItem value={2}>{this.props.translate("all")}</MenuItem>
          <MenuItem value={1}>{this.props.translate("true")}</MenuItem>
          <MenuItem value={0}>{this.props.translate("false")}</MenuItem>
        </TextField>
      </Grid>
      <Grid
        item
        xs={12}
        sm={6}
        md={2}
        style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
      >
        <Button
          variant="contained"
          color="secondary"
          size="small"
          onClick={this.applyFilters}
        >
          {this.props.translate("submit")}
        </Button>
        <Button
          variant="outlined"
          size="small"
          onClick={this.clearFilters}
        >
          {this.props.translate("clear")}
        </Button>
      </Grid>
    </Grid>
  );

  checkFloteNumber(n) {
    return Number(n) === n && n % 1 !== 0;
  }

  setPagination = (user) => {
    if (this.state.pagData) {
      const nUser = { ...user };
      const lastPage = nUser.total / this.state.pageSize;
      const IsFloate = this.checkFloteNumber(lastPage);
      delete nUser.data;
      nUser.pageSize = this.state.pageSize;
      nUser.lastPage = IsFloate ? parseInt(lastPage + 1) : lastPage;
      return nUser;
    }
    return {};
  };

  addItem = () => {
    this.setState({
      selectedItem: "",
      editOption: false,
      addOption: true,
      form: { ...formDefaultState },
      defaultList: false,
    });
  };

  handleChange = (name) => (event) => {
    const value = event?.target?.value ?? "";
    this.setState(
      (preState) => ({
        form: {
          ...preState.form,
          [name]: value,
        },
      }),
      () => this.checkRequiredFields(),
    );
  };

  handleFleetTypesChange = (event) => {
    const value = event?.target?.value ?? "";
    const fleetTypes = this.state.editOption
      ? value
        ? [value]
        : []
      : Array.isArray(value)
        ? value
        : [];

    this.setState(
      (preState) => ({
        form: {
          ...preState.form,
          fleetTypes,
        },
      }),
      () => this.checkRequiredFields(),
    );
  };

  checkRequiredFields() {
    const { category, fleetTypes, baselineInterval, baselineIntervalDays } =
      this.state.form;
    const changed = !isEqual(
      this.state.form,
      formFromItem(this.state.selectedItem),
    );
    const isValid =
      category?.trim() &&
      fleetTypes?.length > 0 &&
      baselineInterval !== "" &&
      !Number.isNaN(parseInt(baselineInterval, 10)) &&
      baselineIntervalDays !== "" &&
      !Number.isNaN(parseInt(baselineIntervalDays, 10));

    if (isValid) {
      this.setState({ isVisableBtn: true });
      if (changed) {
        this.setState({ isVisableBtnforEdit: true });
      }
    } else {
      this.setState({
        isVisableBtn: false,
        isVisableBtnforEdit: false,
      });
    }
  }

  ag_submit = () => {
    const { form } = this.state;
    const payloads = form.fleetTypes.map((fleetType) =>
      pmsDataFormat({ ...form, fleetType }, 0),
    );
    const isMultiple = payloads.length > 1;
    const url = isMultiple
      ? "/api/pmsintervals/postmultiple"
      : "/api/pmsintervals";
    const data = isMultiple ? payloads : payloads[0];
    this.setState({ submitting: true });

    fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((res) => {
        if (res.status === "success") {
          toast.success(this.props.translate("createdSuccessfully"));
        } else if (res?.statusCode === "440") {
          window.location.replace("/login");
        } else if (res.statusCode) {
          const err = res?.message?.split(":");
          if (err?.[1]) {
            toast.error(this.props.translate(err[1].replace(")", "")));
          }
        }
      })
      .catch(() => {
        toast.error(this.props.translate("somethingwentWrong"));
      })
      .finally(() => {
        this.setState(
          {
            addOption: false,
            form: { ...formDefaultState },
            defaultList: true,
            submitting: false,
          },
          () => this.getPmsIntervals(),
        );
      });
  };

  modalControle = () => {
    this.setState({
      addOption: false,
      editOption: false,
      selectedItem: "",
      defaultList: true,
      isVisableBtn: false,
      isVisableBtnforEdit: false,
      form: { ...formDefaultState },
    });
  };

  itemSelection = (item) => {
    if (item?.id) {
      this.fetchPmsIntervalById(item.id);
    }
  };

  onEdit = (selected) => {
    if (selected?.[0]?.id) {
      this.fetchPmsIntervalById(selected[0].id);
    }
  };

  openStatusConfirm = (item) => {
    if (!item?.id) return;
    const isActive =
      item.active !== undefined ? item.active : item.archive === false;
    this.setState({
      statusConfirmOpen: true,
      statusItem: item,
      statusConfirmLabel: isActive
        ? "areYouSureDeactivatePms"
        : "areYouSureActivatePms",
    });
  };

  closeStatusConfirm = () => {
    this.setState({
      statusConfirmOpen: false,
      statusItem: null,
      statusConfirmLabel: "",
    });
  };

  submitStatusChange = () => {
    const { statusItem } = this.state;
    if (!statusItem?.id) return;

    const isActive =
      statusItem.active !== undefined
        ? statusItem.active
        : statusItem.archive === false;

    const obj = pmsDataFormat(
      {
        ...statusItem,
        active: !isActive,
        // archive: isActive,
      },
      statusItem.id,
    );

    this.setState({ submitting: true });

    fetch(`/api/pmsintervals/${statusItem.id}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(obj),
    })
      .then((response) => response.json())
      .then((res) => {
        if (res.status === "success") {
          toast.success(this.props.translate("updatedSuccessfully"));
          this.closeStatusConfirm();
          this.getPmsIntervals();
        } else if (res?.statusCode === "440") {
          window.location.replace("/login");
        } else if (res.statusCode) {
          const err = res?.message?.split(":");
          if (err?.[1]) {
            toast.error(this.props.translate(err[1].replace(")", "")));
          }
        }
      })
      .catch(() => {
        toast.error(this.props.translate("somethingwentWrong"));
      })
      .finally(() => {
        this.setState({ submitting: false });
      });
  };

  ug_submit = () => {
    const itemId = this.state.selectedItem.id;
    const obj = pmsDataFormat(
      {
        ...this.state.selectedItem,
        ...this.state.form,
        fleetType: this.state.form.fleetTypes?.[0] || "",
      },
      itemId,
    );
    this.setState({ submitting: true });

    fetch(`/api/pmsintervals/${itemId}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(obj),
    })
      .then((response) => response.json())
      .then((res) => {
        if (res.status === "success") {
          toast.success(this.props.translate("updatedSuccessfully"));
        } else if (res?.statusCode === "440") {
          window.location.replace("/login");
        } else if (res.statusCode) {
          const err = res?.message?.split(":");
          if (err?.[1]) {
            toast.error(this.props.translate(err[1].replace(")", "")));
          }
        }
      })
      .catch(() => {
        toast.error(this.props.translate("somethingwentWrong"));
      })
      .finally(() => {
        this.setState(
          {
            addOption: false,
            editOption: false,
            form: { ...formDefaultState },
            defaultList: true,
            submitting: false,
          },
          () => this.getPmsIntervals(),
        );
      });
  };

  render() {
    const rowDefinition = [
      {
        id: "category",
        numeric: false,
        disablePadding: false,
        label: this.props.translate("pmsCategory"),
      },
      {
        id: "fleetType",
        numeric: false,
        disablePadding: false,
        label: this.props.translate("fleetType"),
      },
      {
        id: "baselineInterval",
        numeric: false,
        disablePadding: false,
        label: this.props.translate("baselineInterval"),
      },
      {
        id: "baselineIntervalDays",
        numeric: false,
        disablePadding: false,
        label: this.props.translate("baselineIntervalDays"),
      },
      {
        id: "pmsStatus",
        numeric: false,
        disablePadding: false,
        label: this.props.translate("status"),
      },
    ];

    return (
      <div style={{ position: "relative" }}>
        {(this.state.addOption || this.state.editOption) && (
          <AddPmsIntervalModal
            title={
              this.state.addOption
                ? this.props.translate("addUserPms")
                : this.props.translate("editUserPms")
            }
            formSubmit={this.state.addOption ? this.ag_submit : this.ug_submit}
            handleChange={this.handleChange}
            handleFleetTypesChange={this.handleFleetTypesChange}
            isEdit={this.state.editOption}
            form={this.state.form}
            modalControle={this.modalControle}
            buttonText={
              this.state.addOption
                ? this.props.translate("sharedCreate")
                : this.props.translate("update")
            }
            isVisableCreateBtn={
              this.state.addOption
                ? this.state.isVisableBtn
                : this.state.isVisableBtnforEdit
            }
            categories={this.state.categories}
            translate={this.props.translate}
          />
        )}

        {this.state.defaultList ? (
          <>
            <Grid container className="breadcrumb-row">
              <Grid item xs={12} sm={4}>
                <h3 style={{ margin: 0 }}>{this.props.translate("userPms")}</h3>
              </Grid>
              <Grid item xs={12} sm={8} style={{ justifyContent: "flex-end" }}>
                <div style={{ width: "25%", marginRight: 20 }}>
                  <TextField
                    fullWidth
                    label={this.props.translate("search")}
                    value={this.state.itemSearch || ""}
                    onChange={(e) => this.SearchItem(e.target.value)}
                  />
                </div>
                <div style={{ width: "25%", marginRight: 20 }}>
                  <TextField
                    select
                    fullWidth
                    label={this.props.translate("active")}
                    value={this.state.activeFilter}
                    onChange={this.handleActiveFilterChange}
                  >
                    <MenuItem value={2}>{this.props.translate("all")}</MenuItem>
                    <MenuItem value={1}>
                      {this.props.translate("active")}
                    </MenuItem>
                    <MenuItem value={0}>
                      {this.props.translate("inactive")}
                    </MenuItem>
                  </TextField>
                </div>
                <Button
                  aria-label="Create"
                  size="small"
                  color="inherit"
                  onClick={this.addItem}
                  id="createButton"
                  disabled={this.state.categoriesLoading}
                >
                  {this.props.translate("create")}
                </Button>
              </Grid>
            </Grid>
            {this.renderFilterFields()}
            {this.state.loading || this.state.submitting ? (
              <Loader />
            ) : (
              <Table
                rows={this.state.tableData || []}
                pagination={this.setPagination(this.state.pagData)}
                handleChangeRowsPerPage={this.handleChangeRowsPerPage}
                handleChangePage={this.handleChangePage}
                SearchItem={this.SearchItem}
                onDelete={this.removeItem}
                onEdit={this.onEdit}
                onPmsStatusClick={this.openStatusConfirm}
                themecolors={this.props.themecolors}
                isRowIcons={false}
                isCursoPointer
                filterDropdown
                setSerialNo
                rowDefinition={rowDefinition}
                hasAccessOfDelete={true}
                isEditable={true}
                onClick={this.itemSelection}
              />
            )}
          </>
        ) : (
          !this.state.addOption &&
          !this.state.editOption &&
          (this.state.editLoading ? <Loader /> : null)
        )}

        {this.state.onDeleteConfirmation && (
          <ConfirmDialoag
            translate={this.props.translate}
            onCancel={this.onCancel}
            onOk={this.deleteItem}
            title={this.props.translate("areYouWantToDelete")}
            children={`${this.state.selectedItem?.category || ""} - ${this.state.selectedItem?.fleetType || ""}`}
          />
        )}

        {this.state.statusConfirmOpen && (
          <ConfirmDialoag
            translate={this.props.translate}
            onCancel={this.closeStatusConfirm}
            onOk={this.submitStatusChange}
            title={this.state.statusConfirmLabel}
            children={
              <span>
                <span style={{ fontWeight: "bold" }}>
                  {this.props.translate("pmsCategory")} :{" "}
                </span>
                {this.state.statusItem?.category || ""}
              </span>
            }
          />
        )}
      </div>
    );
  }
}

const mapState = (state) => ({
  logInUser: state.logInUsers,
  themecolors: state.themecolors,
});

export const UserPmsList = connect(mapState)(PmsIntervalsList);
